import { GetterTree } from 'vuex';

import { ProfileState } from '@/store/modules/profile/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ProfileState, RootState> = {

  data: (state: ProfileState) => state.data,
  isLoaded: (state: ProfileState) => state.isLoaded,

};
